import { render } from "./NewsModalError.vue?vue&type=template&id=0412372a"
import script from "./NewsModalError.vue?vue&type=script&lang=js"
export * from "./NewsModalError.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn});
